import { styled } from '@mui/material';
import { Box } from '@mui/system';
import { PropsWithChildren } from 'react';
import EnviromentWarningBar, {
  ENV_WARNING_BAR_HEIGHT,
} from '../../base/components/EnviromentWarningBar/EnviromentWarningBar';
import { Flex } from '../../base/components/Flex';
import { LAYOUT_SCROLL_DISABLED } from './ClientLayout';

type Props = PropsWithChildren<{}>;

const LaunchQRLayout = ({ children }: Props) => {
  return (
    <LaunchQRLayoutPageWrapper
      flexDirection="column"
      height="100dvh"
      overflow="hidden"
    >
      <EnviromentWarningBar />
      <LaunchQRLayoutWrapper>{children}</LaunchQRLayoutWrapper>
    </LaunchQRLayoutPageWrapper>
  );
};

export default LaunchQRLayout;

const LaunchQRLayoutPageWrapper = styled(Flex)(
  ({ theme: { palette } }) => `
  position: relative;
  background-color: ${palette.background.default};

  @media print {
    height: auto;
    overflow: visible;
  }
`,
);

const LaunchQRLayoutWrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: calc(100% - ${ENV_WARNING_BAR_HEIGHT});
  overflow: auto;
  align-items: center;

  body.${LAYOUT_SCROLL_DISABLED} & {
    overflow: hidden;
  }

  @media print {
    max-height: unset;
  }
`;
